import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Supplier/constants'
import { Report, ReportFilterFields, ReportMainSearchFields } from 'Portals/Supplier/entities'
import i18n from 'Portals/Supplier/utils/i18nService'

export const mainSearchConfig: Report.Search.Config = {
	[ReportMainSearchFields.reportName]: {
		label: i18n.t('pages:report.filters.reportName'),
		apiFieldName: ReportMainSearchFields.reportName,
		apiSearchFieldName: 'reportName',
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.reportName
	}
}

export const getFilterConfig = (): Report.Filter.Config => ({
	[ReportFilterFields.dateFrom]: {
		label: i18n.t('pages:report.filters.generateDateFrom'),
		apiFilterFieldName: 'rangeFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[ReportFilterFields.dateTo]: {
		label: i18n.t('pages:report.filters.dateTo'),
		apiFilterFieldName: 'rangeTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[ReportFilterFields.status]: {
		label: i18n.t('pages:report.filters.status'),
		apiFilterFieldName: 'status',
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.status,
		defaultValue: ''
	}
})
